import React from 'react'
import { SvgIconProps } from './Home'

const SvgScreenedIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "24"}
    height={height ?? "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill ?? "#353535"}
      d="M17.01 3.305h-1.447C15.395 2.56 14.694 2 13.858 2h-3.716c-.837 0-1.536.56-1.706 1.305H6.99C5.34 3.305 4 4.573 4 6.133v13.039C4 20.732 5.341 22 6.99 22h10.02C18.658 22 20 20.73 20 19.172V6.133c0-1.56-1.341-2.828-2.99-2.828zm-7.224.346c0-.186.16-.338.357-.338h3.715c.197 0 .357.152.357.338v.96h-4.43v-.96zm8.826 15.521c0 .834-.719 1.514-1.602 1.514H6.99c-.882 0-1.6-.68-1.6-1.514V6.133c0-.835.718-1.514 1.6-1.514h1.407v.648c0 .363.311.657.694.657h5.819c.383 0 .694-.294.694-.657V4.62h1.406c.883 0 1.602.68 1.602 1.514v13.039z"
    ></path>
    <path
      fill="#31B465"
      d="M14.959 10.707c0-.058-.056-.117-.11-.117l-.221-.234c-.055-.117-.11-.175-.165-.234-.166-.117-.386-.175-.552-.058l-.055.058-.165.176c-.22.234-.441.468-.607.702-.275.292-.55.585-.882.935-.275.293-.55.527-.771.82-.11.116-.221.175-.331.292-.055-.059-.11-.117-.166-.234l-.55-.585c-.056-.059-.111-.117-.221-.175l-.166-.176c-.11-.059-.22 0-.33.058-.056.059-.11.059-.166.117l-.22.234c-.056.117-.166.176-.22.234a.456.456 0 00.054.527l.276.292c.165.176.33.351.496.585l.551.585.331.351c.055.059.11.117.22.117.166.059.276 0 .386-.117a.767.767 0 00.22-.175l.332-.351.496-.527.551-.585.551-.585.552-.585c.11-.117.275-.292.44-.409l.276-.292.166-.176c.055-.175.055-.35 0-.468z"
    ></path>
  </svg>
)

export default SvgScreenedIcon
